module.exports = __webpack_public_path__ + "img/impiantoverde.bfc3733f.png";